<div class="flex flex-col items-center justify-center">
  <mat-spinner *ngIf="loading" diameter="32"></mat-spinner>
</div>